import clsx from 'clsx';
import { type FC, type ReactNode } from 'react';

import { WithClassName } from '../../../../types/react';
import { Flex } from '../Flex';

import styles from './Control.module.scss';

export type ControlState = 'default' | 'error';

export type ControlOuterProps = {
  label?: string;
};

export type ControlProps = WithClassName &
  ControlOuterProps & {
    controlId?: string;
    error?: ReactNode;
    children?: ReactNode;
  };

export const Control: FC<ControlProps> = (props) => {
  const { className, controlId, label, error, children } = props;

  return (
    <Flex className={clsx(styles.root, className)} direction="column">
      {label && (
        <label className={styles.label} htmlFor={controlId}>
          {label}
        </label>
      )}

      {children}

      <div className={styles.error}>{error || '\u00a0'}</div>
    </Flex>
  );
};
